export default {
  TITLE: "Tito - O celular do surto",
  LOGO: "./assets/images/logo-pt-br.png",
  TAB: "Tito e os pássaros",
  SUBTITLE: "O celular do surto",
  DOWNLOAD_TITLE: "Professores e Educadores",
  DOWNLOAD_TEXT: "Baixe aqui os conteúdos para usar o jogo em sua escola",
  DOWNLOAD_BUTTON: "Fazer download",
  PLAY_TEXT:
    "Conheça a aventura de Tito e seus amigos para salvar o mundo da doença do medo.",
  PDF_LINK: "./tito-material-didatico-pt-br.pdf",
  TITO_LINK: "http://titoeospassaros.com.br/",
  SITE_URL: "http://titoandthebirds.com/game/#/pt-br",
  SITE_DESCRIPTION:
    "Professores, crianças, pais e educadores - Aprenda a combater Fake News com Tito e os Pássaros",
  COPYRIGHT: `Tito - O celular do surto by <a href="http://pushstart.com.br/" target="_blank" rel="noopener noreferrer"
  >PushStart</a>. © 2019 Bits Filmes. Todos os direitos reservados`,
  PIXEL_CONVERSION_PTBR:
    "https://secure.adnxs.com/px?id=1087807&seg=17258326&t=2"
};



// WEBPACK FOOTER //
// ./src/utils/locales/pt-BR.js